<template>
  <!-- Titres du markdown rendu : taille seule (sans interlignage) pour conserver le rendu d'origine -->
  <div
    class="mb-6 [&_h2]:mt-6 [&_h2]:mb-3 [&_h2]:text-[1.5rem] [&_h2]:font-bold [&_h2]:text-gray-900 [&_h3]:mt-5 [&_h3]:mb-2 [&_h3]:text-[1.25rem] [&_h3]:font-semibold [&_h3]:text-gray-800"
  >
    <MarkdownText :content="content" />
  </div>
</template>

<script>
import { MarkdownText } from "@estaly/ui";

export default {
  name: "TextSection",
  components: { MarkdownText },
  props: {
    content: { type: String, required: true },
  },
};
</script>
